import React from 'react'
import animated_bloqcube_logo from "./../../assets/images/logo/bloqcube-logo-animated.json"
import Lottie from 'lottie-react';

const AnimatedBloqcubeLogo = (props) => {
    return <Lottie animationData={animated_bloqcube_logo} loop={true} {...props} />;
}

export default AnimatedBloqcubeLogo
